import {
  palettes,
  createBaseThemeOptions,
  createUnifiedTheme,
  PageTheme,
  genPageTheme,
  shapes,
  pageTheme as defaultPageThemes,
} from '@backstage/theme';

// const backstagePageThemeColorVariants = {
//   darkGrey: ['#171717', '#383838'],
//   marineBlue: ['#006D8F', '#0049A1'],
//   veryBlue: ['#0027AF', '#270094'],
//   rubyRed: ['#98002B', '#8D1134'],
//   toastyOrange: ['#BE2200', '#A41D00'],
//   purpleSky: ['#8912CA', '#3E00EA'],
//   eveningSea: ['#00FFF2', '#035355'],
//   teal: ['#005B4B'],
//   pinkSea: ['#C8077A', '#C2297D'],
//   greens: ['#4BB8A5', '#187656'],
// };

/**
 * Page Themes define the page header banner pattern and color.
 * It also defines the template component color
 * Themes are stored as a dictionary: Record<string, PageTheme> where string is a themeID (ie, documentation, home, apis, etc).
 * See {@link defaultPageThemes} for default themes.
 *
 * @public
 */
const boxboatPageTheme: Record<string, PageTheme> = {
  ...defaultPageThemes,
  home: genPageTheme({
    colors: ['#000000', '#000000'],
    shape: shapes.round,
  }),
  apis: genPageTheme({
    colors: ['#000000', '#000000'],
    shape: shapes.round,
  }),
  documentation: genPageTheme({
    colors: ['#000000', '#000000'],
    shape: shapes.round,
  }),
  tool: genPageTheme({
    colors: ['#000000', '#000000'],
    shape: shapes.round,
  }),
  service: genPageTheme({
    colors: ['#000000', '#000000'],
    shape: shapes.round,
  }),
  database: genPageTheme({
    colors: ['#000000', '#000000'],
    shape: shapes.round,
  }),
  compute: genPageTheme({
    colors: ['#000000', '#000000'],
    shape: shapes.round,
  }),
  configuration: genPageTheme({
    colors: ['#000000', '#000000'],
    shape: shapes.round,
  }),
  github: genPageTheme({
    colors: ['#000000', '#000000'],
    shape: shapes.round,
  }),
};

export const boxboatThemes = {
  light: createUnifiedTheme({
    ...createBaseThemeOptions({
      palette: {
        ...palettes.light,
        background: {
          default: '#ffffff',
          paper: '#ffffff',
        },
        primary: {
          main: '#000000',
        },
        navigation: {
          background: '#000000',
          color: '#ffffff',
          indicator: '#ffffff',
          selectedColor: '#ffffff',
          navItem: {
            hoverBackground: '#161616',
          },
          submenu: {
            background: '#161616',
          },
        },
      },
    }),
    components: {
      BackstageHeader: {
        styleOverrides: {
          header: {
            backgroundImage: 'none',
            backgroundColor: '#000000',
            boxShadow: 'none',
          },
        },
      },
    },
    pageTheme: boxboatPageTheme,
    defaultPageTheme: 'home',
  }),
  dark: createUnifiedTheme({
    ...createBaseThemeOptions({
      palette: {
        ...palettes.dark,
        background: {
          default: '#000000',
          paper: '#161616',
        },
        primary: {
          main: '#ffffff',
        },
        navigation: {
          background: '#000000',
          color: '#f4f4f4',
          indicator: '#ffffff',
          selectedColor: '#ffffff',
          navItem: {
            hoverBackground: '#161616',
          },
          submenu: {
            background: '#161616',
          },
        },
      },
    }),
    components: {
      BackstageHeader: {
        styleOverrides: {
          header: {
            backgroundImage: 'none',
            backgroundColor: '#000000',
            boxShadow: 'none',
          },
        },
      },
    },
    pageTheme: boxboatPageTheme,
    defaultPageTheme: 'home',
  }),
};

